import { TMeasurementQcDB } from '@monorepo/types';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectMeasurementQcStore = createFeatureSelector<TMeasurementQcDB>('MEASUREMENT_QC_DB');

export const selectBctxMap = createSelector(selectMeasurementQcStore, (store) => store.bctxMap);

export const lastMeasuredTagData = createSelector(selectMeasurementQcStore, (store) => store.lastMeasuredTagData);

export const selectLastMeasuredBctxDetails = createSelector(
  lastMeasuredTagData,
  selectBctxMap,
  (lastMeasuredTagData, bctxMap) => {
    if (lastMeasuredTagData && lastMeasuredTagData.bctxKey in bctxMap) {
      return bctxMap[lastMeasuredTagData.bctxKey];
    }
    return null;
  },
);

export const lastFetchedTagData = createSelector(selectMeasurementQcStore, (store) => store.lastFetchedTagData);

export const selectLastFetchedBctxDetails = createSelector(
  lastFetchedTagData,
  selectBctxMap,
  (lastFetchedTagData, bctxMap) => {
    if (lastFetchedTagData && lastFetchedTagData.bctxKey in bctxMap) {
      return bctxMap[lastFetchedTagData.bctxKey];
    }
    return null;
  },
);

export const getBctxDetailsByBctxKey = (bctxKey: string) =>
  createSelector(selectBctxMap, (bctxMap) => {
    if (bctxKey in bctxMap) return bctxMap[bctxKey];
    return null;
  });
